import CityPageTemplate from "../city-template/CityPageTemplate";
import { livermoreConfig } from "./data";

export default function LivermorePage() {
  return <CityPageTemplate config={livermoreConfig} />;
}